import { observer } from "mobx-react-lite";

import { NodeFieldLabel } from "@/components/doc/right-sidebar/active-node-style/fields/NodeTextField";
import { InlineNodeComponent } from "@/components/expression/InlineNode";
import { NodeStyleProvider } from "@/components/expression/utils/NodeStyleProvider";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeModel } from "@/models/nodes/types";

type Props = {
  doc: DocumentModel;
  expressions?: NodeModel[][];
};

export const GraphPreviewSelection = observer(function GraphPreviewSelection({
  doc,
  expressions,
}: Props) {
  if (!expressions || expressions.length === 0) {
    return null;
  }

  return (
    <NodeStyleProvider renderContext="right-sidebar" size="sm">
      <div>
        {expressions.map((expr, index) => (
          <NodeFieldLabel
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            as="div"
            className="p-1 [&:not(:last-child)]:mb-2 min-h-[28px] flex-col items-start shadow-block dark:shadow-block-inverted overflow-auto no-scrollbar cursor-default"
          >
            <InlineNodeComponent
              doc={doc}
              nodes={expr}
              className="pointer-events-none font-mono opacity-60"
            />
          </NodeFieldLabel>
        ))}
      </div>
    </NodeStyleProvider>
  );
});
